import {Component, OnInit, OnDestroy} from "@angular/core";
import {UserService} from "../../services/data/user.service";
import {AuthentService} from "../../services/authent.service";
import {Router, ActivatedRoute} from "@angular/router";
import {BusinessService} from "../../services/data/business.service";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {PublicService} from "../../services/data/public.service";
import {NotificationsService} from "angular2-notifications/components";
import {ContactForm} from "./contact-form";
import {ConfigurationService} from "../../services/configuration.service";
import {Subscription} from "rxjs";

declare const $: any;

@Component({
  selector: 'index',
  template: require('./index.component.html'),
  styles: [
    require('./index.component.scss')
  ]
})
export class IndexComponent implements OnInit, OnDestroy {

  loginModel: LoginForm = new LoginForm();
  loginSubmitted: boolean = false;
  loginError: boolean = false;

  subscriptionModel: SubscriptionForm = new SubscriptionForm();
  registerSubmitted: boolean = false;

  differentPassword: boolean = false;
  emailExist: boolean = false;

  contactForm: ContactForm = new ContactForm();
  contactSubmitted: boolean = false;
  private token: string;

  cguLink: string;

  private paramSubscription: Subscription = null;

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }

  ngOnInit() {
    this.paramSubscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        let token = param['businessId'];

        if (token != null) {
          this.token = token;
          this.authentService.setToken(this.token);
          this.getPrincipal();
        }

        this.initApp();
      });
  }

  constructor(private userService: UserService,
              private authentService: AuthentService,
              private router: Router,
              private businessService: BusinessService,
              private currentBusinessService: CurrentBusinessService,
              private publicService: PublicService,
              private notificationService: NotificationsService,
              private activatedRoute: ActivatedRoute, private configuration: ConfigurationService) {


    this.cguLink = configuration.getFamiliesUrl() + '/cgu';
  }

  private initApp() {
    if (this.authentService.getToken() != null && this.authentService.getToken() != '') {
      this.router.navigateByUrl('/home/events');
    }

    $(document).on('click', '.page-scroll', function (event) {
      event.preventDefault();
      let id = $(this).attr('href');
      let top = $(id).offset().top;

      $('html,body').animate({scrollTop: top}, 'swing');
    });

    $('.navbar-collapse ul li a').click(function () {
      $('.navbar-toggle:visible').click();
    });

    $(document).on('click', '.btn-contact', function () {
      $('.contact-link').trigger('click');
    });

    $(document).scroll(function () {
      let scroll = $(window).scrollTop();
      let $mainNav = $('#mainNav');

      if (scroll > 50) {
        $mainNav.addClass('affix');
        $mainNav.removeClass('affix-top');
      } else {
        $mainNav.addClass('affix-top');
        $mainNav.removeClass('affix');
      }
    });
  }

  login() {
    this.loginSubmitted = true;

    this.doLogin(this.loginModel.email, this.loginModel.password);
  }

  private doLogin(email: string, password: string) {
    email = encodeURIComponent(email);
    password = encodeURIComponent(password);

    this.loginError = false;

    this.userService.getToken(email, password)
      .subscribe(
        token => {
          this.authentService.setToken(token.access_token);
          this.getPrincipal();
          this.loginSubmitted = false;
        },
        error => {
          this.loginSubmitted = false;
          this.loginError = true;
        }
      );
  }

  dataChanged() {
    this.loginError = false;
    this.emailExist = false;
    this.passwordChange();
  }

  passwordChange() {
    if (this.subscriptionModel.registerPassword != this.subscriptionModel.passwordCheck) {
      this.differentPassword = true;
    } else {
      this.differentPassword = false;
    }
  }

  register() {
    this.registerSubmitted = true;
    this.emailExist = false;

    this.userService.register(this.subscriptionModel)
      .subscribe(
        member => {
          this.doLogin(member.email, this.subscriptionModel.registerPassword);
        },
        error => {
          this.registerSubmitted = false;
          this.emailExist = true;
        }
      );
  }

  loadBusinesses(): void {
    this.businessService.getBusinesses().subscribe(
      businesses => {
        if (businesses.length > 1 || businesses.length == 0) {
          this.currentBusinessService.changeBusinesses(businesses);
          this.router.navigateByUrl('/businesses');
        } else {
          this.currentBusinessService.changeBusinesses(businesses);
          this.currentBusinessService.changeBusiness(businesses[0]);

          this.businessService.getRight(businesses[0].id).subscribe(
            right => {
              this.authentService.setRight(right);
              this.router.navigateByUrl('/home/events');
            }
          );
        }

      }
    )
  }

  getPrincipal(): void {
    this.userService.getPrincipal()
      .subscribe(
        user => {
          this.authentService.setUser(user);
          this.loginSubmitted = false;
          this.loadBusinesses();
        },
        error => {
        }
      );
  }

  sendContact() {
    this.publicService.sendContact(this.contactForm).subscribe(
      response => {
        this.notificationService.success('Contact', 'Votre demande de contact a bien été envoyé');
        this.contactForm = new ContactForm();
      },
      error => this.notificationService.error('Contact', 'Une erreur est survenue lors de l\'envoi de votre demande')
    );
  }

  connectEnter(event: KeyboardEvent) {
    if (!this.loginSubmitted && this.loginModel.email != '' && this.loginModel.password != '') {
      this.login();
    }
  }

  subscribeEnter(event: KeyboardEvent) {
    if (this.subscriptionModel.name != '' &&
      this.subscriptionModel.email != '' &&
      this.subscriptionModel.registerPassword != '' &&
      this.subscriptionModel.passwordCheck != '' && !this.registerSubmitted && !this.differentPassword) {
      this.register();
    }
  }

}

class LoginForm {
  email: string = "";
  password: string = "";
}

class SubscriptionForm {
  name: string = "";
  email: string = "";
  registerPassword: string = "";
  passwordCheck: string = "";
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/index/index.component.ts